const AdminFooter = ({ isSidebarMinimized }) => {
    const currentYear = new Date().getFullYear();

    const footerStyle = {
        position: "fixed",
        marginLeft: isSidebarMinimized ? "80px" : "250px",
        left: 0,
        bottom: 0,
        width: "100%",
        padding: "10px 0",
        backgroundColor: "#F1F4F9",
        textAlign: "center", // fallback
    };

    return (
        <footer className="footer" style={footerStyle}>
            <div className="container d-flex justify-content-center align-items-center" style={{ height: "100%", margin: 0 }}>
                <div className="col-auto">
                    {currentYear} &copy; Power Trading Company
                </div>
            </div>
        </footer>
    );
};

export default AdminFooter;